export default __webpack_public_path__ + "static/media/image-bloqueo.46e0f33c.png";